export default __webpack_public_path__ + "static/media/Skup Pula (13).e49137c3.JPG";